import { render, staticRenderFns } from "./basicStep.vue?vue&type=template&id=7b60a18e&scoped=true"
import script from "./basicStep.vue?vue&type=script&lang=js"
export * from "./basicStep.vue?vue&type=script&lang=js"
import style0 from "./basicStep.vue?vue&type=style&index=0&id=7b60a18e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b60a18e",
  null
  
)

export default component.exports